import loadable from '@loadable/component';

export const ForgotPasswordPageContainerLoadable = loadable(
  () => import('./ForgotPasswordPageContainer'),
  { resolveComponent: (module) => module.ForgotPasswordPageContainer },
);
